"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCalendarSettingsContext = exports.CalendarSettingsProvider = exports.CalendarSettingsContext = void 0;
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const use_calendar_settings_1 = require("@app/util/use-calendar-settings");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const uuid_1 = require("uuid");
exports.CalendarSettingsContext = react_1.default.createContext(undefined);
const calendarSettingsTabs = [
    { ico: 'template', label: 'VIEW', value: 'view' },
    { ico: 'monitor', label: 'SHIFT', value: 'shift' },
    {
        ico: 'overview',
        label: 'TIMEOFF',
        value: 'timeoff',
    },
    // {
    //   ico: 'warning',
    //   label: 'WARNING',
    //   value: 'warning',
    // },
    {
        ico: 'info',
        label: 'LEGEND',
        value: 'legend',
        position: 'bottom',
    },
];
const CalendarSettingsProvider = ({ children }) => {
    const options = (0, store_1.useRootSelector)((state) => state.me.options?.filter(util_1.isValue) ?? []);
    const [selectedTab, setSelectedTab] = react_1.default.useState('view');
    const [loading, setLoading] = react_1.default.useState(false);
    const initialFormData = (0, use_calendar_settings_1.useCalendarSettings)();
    const { control, handleSubmit, formState, reset, getValues } = (0, react_hook_form_1.useForm)({
        defaultValues: initialFormData,
    });
    const processedCalendarTabs = react_1.default.useRef(calendarSettingsTabs.map((tab) => ({
        ...tab,
        id: (0, uuid_1.v4)(),
        label: (0, util_1.t)(tab.label),
    })));
    const context = {
        options,
        selectedTab,
        setSelectedTab,
        calendarSettingsTabs: processedCalendarTabs.current,
        loading,
        setLoading,
        control,
        handleSubmit,
        isDirty: formState.isDirty,
        reset,
        getValues,
    };
    return (react_1.default.createElement(exports.CalendarSettingsContext.Provider, { value: context }, children?.(context)));
};
exports.CalendarSettingsProvider = CalendarSettingsProvider;
const useCalendarSettingsContext = () => {
    const context = react_1.default.useContext(exports.CalendarSettingsContext);
    if ((0, util_1.isUndefined)(context)) {
        throw new Error('CalendarSettingsContext must be used withing CalendarSettingsProvider');
    }
    return context;
};
exports.useCalendarSettingsContext = useCalendarSettingsContext;
